// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  showErrorInfo: true,
  disableCache: true,
  reCaptchaKey: '6LeSrr4UAAAAAGHEYindxGAti7X8ubLxj4zVqHsh',
  token: {
    clientOrigin: 'NgOpac',
    clientExpected: 'kvFqFy1i0Y4eUJhM',
  },
  apiUrl: `${window.location.origin}/opac/api/v2`,
  supabaseUrl: 'https://ykjkebgtudstapccczeq.supabase.co',
  supabaseKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlramtlYmd0dWRzdGFwY2NjemVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY4NDQ0MzMsImV4cCI6MjA1MjQyMDQzM30.sFChjkk4mmAsyyv7avDVOIcb1XxKPLDK94ADceFvO5k',
  cafDataUrl: 'https://caf-data.test.odilo.io',
  clarityApiKey: '',
  amplitudeApiKey: '',
  birdieClientId: '',
  claveUnica: {
    baseUrl: 'https://fusedev.patrimoniocultural.gob.cl/',
    clientId: '213717',
  },
  translationsBaseUrl: 'https://translations.odilo.io/',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
